module.exports = __webpack_public_path__ + "static/media/server.fa1e67d0.svg";